<template>
    <header class="siteheader sticky-top">
        <div class="siteheader__container opCookies-header">
            <LogoTextTransition v-if="isMobile" key="logo-text"/>
            <LogoText v-if="!isMobile"/>
            <RollTextButton v-if="scrolled && ( button_type === 'roll-text')" key="roll-button"
                            :firstline="'Grijp het tijdelijke aanbod'" :secondline="'Krijg een GRATIS cadeau'"/>
            <b-button v-else key="static-button" class="button is-primary next-button opcookies-button"
                      @click="nextStep()">
                Grijp het aanbod
            </b-button>
        </div>
    </header>
</template>

<script>
import LogoText from "../_commons/nl/LogoText.vue";
import RollTextButton from "./RollTextButton.vue";
import LogoBullet from "../_commons/nl/LogoBullet.vue";
import mixin from "../../components/form/steps/travel_step_mixin";
import image_mixin from "../_commons/fr/mixins/image_mixin";
import LogoTextTransition from "../_commons/nl/LogoTextTransition.vue";

export default {
    mixins: [mixin, image_mixin],
    components: {LogoTextTransition, LogoBullet, LogoText, RollTextButton},
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        },
        isMobile() {
            return window.innerWidth <= 768;
        }
    },
    data() {
        return {
            scrolled: false
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrolled = window.scrollY > 0;
        }
    }
};
</script>

